<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '1.5rem',
    },
    height: {
      type: [String, Number],
      default: '1.5rem',
    },
    title: {
      type: String,
      default: 'Remove styles',
    },
    isDecorative: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ariaLabel() {
      return this.isDecorative ? null : this.title
    },
  },
}
</script>
<template>
  <svg
    role="img"
    :aria-label="ariaLabel"
    :aria-hidden="isDecorative"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :style="{ width, height }"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{{ title }}</title>
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4 18 7.825 6.949A1.44 1.44 0 0 1 9.192 6c.62 0 1.171.382 1.367.949L13 14H5.385m7.861.838 3.592-3.592s.553-.554 1.107 0l2.809 2.81s.554.553 0 1.106l-3.592 3.592s-.553.554-1.107 0l-2.809-2.81s-.554-.553 0-1.106M12.773 16l-1.301 1.442c-.63.71-.63 1.86 0 2.57l.64.721c.151.17.356.267.57.267h1.753a.77.77 0 0 0 .57-.267L16 19.636"/>
  </svg>
</template>
